import script from "./PaymentCancelled.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentCancelled.vue?vue&type=script&setup=true&lang=js"

import "./PaymentCancelled.vue?vue&type=style&index=0&id=94d776bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94d776bc"]])

export default __exports__